import React from "react";
import { useEffect, useState } from "react";
import { Edit, Trash2, Plus } from "lucide-react";
import { postData } from "../../../services/NodeServices";
import { toast } from "react-toastify";

// Mock functions for demonstration - replace with your actual imports



export default function AddressComp({ address, setAddress, mode = 'list' }) {
  const [addressList, setAddressList] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(0);

  const getAddress = async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const result = await postData('api/users/address', { userid: user.userid });

      if (result.status) {
        setAddressList(result.data || []);
        if (result.data && result.data.length > 0) {
          setAddress(result.data[0]);
        }
        console.log(result.data);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log('Error fetching addresses');
    }
  };

  useEffect(() => {
    getAddress();
  }, []);

  const handleSelected = (item, index) => {
    setSelectedAddress(index);
    setAddress(item);
  };

  const deleteAddress = async (item) => {
    try {
      const result = await postData('api/users/addressdelete', { addressid: item.addressid });
      console.log(result);
      if (result.status) {
        toast.success('Address deleted successfully');
        getAddress();
      }
    } catch (error) {
      toast.error('Error deleting address');
    }
  };

  const handleAddAddress = () => {
    if (mode === 'quick') {
      console.log('Navigate to instant buy add address');
    } else {
      console.log('Navigate to cart add address');
    }
  };

  const handleEditAddress = (addressId) => {
    console.log(`Navigate to edit address: ${addressId}`);
  };

  return (
    <div className="space-y-3">
      {addressList && addressList.length > 0 ? (
        addressList.map((item, index) => (
          <div
            key={index}
            className={`border rounded-lg p-4 cursor-pointer transition-colors bg-white ${
              index === selectedAddress 
                ? 'border-orange-500' 
                : 'border-gray-200 hover:border-gray-300'
            }`}
            onClick={() => handleSelected(item, index)}
          >
            <div className="flex justify-between items-start mb-2">
              <h4 className="font-medium text-sm text-black text-left">{item.username}</h4>
              <div className="flex gap-1">
                <button
                  className="p-1 text-gray-400 hover:text-orange-500"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEditAddress(item.addressid);
                  }}
                >
                  <Edit className="w-3 h-3" />
                </button>
                <button
                  className="p-1 text-gray-400 hover:text-red-500"
                  onClick={(e) => {
                    e.stopPropagation();
                    deleteAddress(item);
                  }}
                >
                  <Trash2 className="w-3 h-3" />
                </button>
              </div>
            </div>

            <p className="text-xs text-black mb-1 text-left">
              {`${item.addline1}${item.addline2 ? ', ' + item.addline2 : ''}, ${item.city}, ${item.state} ${item.zipcode}`}
            </p>
            
            <p className="text-xs text-black mb-3 text-left">{item.mobileno}</p>

          <div className="flex flex-row justify-start w-full">  <button
              className={`px-3 py-1 text-xs rounded border transition-colors ${
                index === selectedAddress
                  ? 'bg-orange-500 text-white border-orange-500'
                  : 'bg-white text-black border-orange-500 hover:bg-orange-500 hover:text-white'
              }`}
              onClick={(e) => {
                e.stopPropagation();
                handleSelected(item, index);
              }}
            >
              {index === selectedAddress ? 'Selected' : 'Select'}
            </button></div>
          </div>
        ))
      ) : (
     <a href="/cart/add-address" className="mt-2">   <div className="border border-gray-200 rounded-lg p-4 text-left bg-white">
          <p className="text-sm text-black mb-2">No addresses found</p>
          <p className="text-xs text-black">Please add an address to continue</p>
        </div></a>
      )}
        <a href="/cart/add-address" className="mt-4">   
      <div
        className="border border-dashed border-orange-500 rounded-lg p-4 mt-3 text-left cursor-pointer hover:bg-orange-50 transition-colors bg-white"
        onClick={handleAddAddress}
      >
        <div className="flex items-center gap-2 mb-2">
          <Plus className="w-4 h-4 text-orange-500" />
          <span className="text-sm font-medium text-black">Add Address</span>
        </div>
        <p className="text-xs text-black">Add new delivery address</p>
      </div>
      </a>
    </div>
  );
}